import React from "react";
import { Modal, ModalHeader, ModalBody, Spinner } from "reactstrap";

const LoadingModal = ({ isOpen, toggle, text }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>Aguarde</ModalHeader>
      <ModalBody className="text-center">
        <Spinner style={{ width: "3rem", height: "3rem" }} />
        <p className="mt-3">{text}</p>
      </ModalBody>
    </Modal>
  );
};

export default LoadingModal;
